import * as React from 'react';
import * as style from './BulkUploadCategorySingleDiff.styl';

import { ICategoryDiff } from '@Shared/bulk_upload';

interface IBulkUploadCategorySingleDiffProps {
  diff: ICategoryDiff;
}

function constructField(key: string, value: string | number | boolean, header: string, errorMap: Record<string, string>) {
  return (
    <div className="field">
      {header}: {value || <em>None</em>}
      {errorMap[key] ? <span className="error">{errorMap[key]}</span> : null}
    </div>
  );
}

export class BulkUploadCategorySingleDiff extends React.Component<IBulkUploadCategorySingleDiffProps> {
  constructor(props: IBulkUploadCategorySingleDiffProps) {
    super(props);
  }

  render() {
    const { diff } = this.props;

    const teamFieldString = diff.scopedExpenseTags.length ? diff.scopedExpenseTags.map((tag) => tag.name).join(', ') : '';
    // mappedValues may be undefined
    const mappedValueString = diff.mappedValues && diff.mappedValues.length ? diff.mappedValues.join(', ') : '';

    return (
      <div className={style.global}>
        <em className="identifier">{diff.categoryName}</em>
        <div className="fields">
          {diff.parentCategoryName && constructField('parentCategoryName', diff.parentCategoryName, 'Parent Category', diff.fieldErrorMap)}
          {Boolean(teamFieldString) && constructField('scopedExpenseTags', teamFieldString, 'Scope to', diff.fieldErrorMap)}
          {Boolean(diff.mappedValues) && constructField('mappedValues', mappedValueString, 'Chart of Accounts', diff.fieldErrorMap)}
        </div>
        <br />
      </div>
    );
  }
}
